import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getPageProductType } from "api/ProductTypeApi";
import { ProductCateCountApi } from "api/ProductCategoryApi";
import { getAllProductCate } from "api/ProductCategoryApi";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import SEO from "./Seo";
import { genderBasedIcons } from "components/GenderBasedIcons";
import Noimg from "../../images/no_img.jpg";

export default function CategorysMenu({ isMobile = false, onClose, lang = "en", t = (k) => k }) {
  const [data, setData] = useState([]);
  const [headerCategories, setHeaderCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]); // eslint-disable-line
  const [activeMenu, setActiveMenu] = useState(null);
  const [count, setCount] = useState([]); // eslint-disable-line
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1440
  );
  const lists = ["gold", "silver", "diamond", "platinum"];
  const history = useNavigate();

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Responsive category count — desktop only. Mobile menu always shows full list.
  const getVisibleCount = (width) => {
    if (width >= 1440) return 8;
    if (width >= 1280) return 7;
    if (width >= 1100) return 6;
    if (width >= 1025) return 5;
    return headerCategories.length; // mobile/tablet uses full list (no nav cap)
  };

  const visibleCount = getVisibleCount(windowWidth);
  const visibleCategories = isMobile ? headerCategories : headerCategories.slice(0, visibleCount);
  const overflowCategories = isMobile ? [] : headerCategories.slice(visibleCount);

  useEffect(() => { getProductType(); }, []); // eslint-disable-line

  const getProductCount = useCallback((productId) => { // eslint-disable-line
    ProductCateCountApi({ visibilityMode: "MOBILE", productType: productId, allowCatalogue: 1 })
      .then((res) => setCount(res.response));
  }, []);

  useEffect(() => {
    getAllProductCate({}).then((res) => {
      setHeaderCategories(res.response.filter(
        (i) => i.visibilityMode === "WEB_MOBILE" || i.visibilityMode === "MOBILE"
      ));
    });
  }, []); // eslint-disable-line

  useEffect(() => {
    getAllProductSubCate({}).then((res) => setSubCategories(res.response));
  }, []); // eslint-disable-line

  const getProductType = () => {
    const arr1 = [], arr2 = [];
    let isChecked = false;
    getPageProductType({ active: 1 }).then((res) => {
      const response = res.response.content;
      lists.forEach((item, idx) => {
        if (!isChecked) {
          arr1.push(...response.filter((x) => x.name.toLowerCase() === item));
          arr2.push(...response.filter((x) => x.name.toLowerCase() !== item));
          isChecked = true;
        } else {
          arr1.push(...arr2.filter((x) => x.name.toLowerCase() === item));
          const ne = arr2.filter((x) => x.name.toLowerCase() !== item);
          arr2.length = 0;
          arr2.push(...ne);
        }
        if (lists.length - 1 === idx) arr1.push(...arr2);
      });
      setData(arr1.slice(0, 6));
    });
  };

  const imgSrc = (url) => (!url || url === "Image_Not_Available" || url === "-") ? Noimg : url;

  // Navigate with full category object so subcategory updates correctly
  const navigateToCategory = (cat) => {
    history("/ProductList", { state: { category: cat } });
    setActiveMenu(null);
  };

  // ── Services dropdown ────────────────────────────────────────────────────
  const ServicesDropdown = () => (
    <div style={{
      position: "absolute", top: "110%", right: 0,
      background: "#fff", borderRadius: 16,
      boxShadow: "0 20px 60px rgba(0,0,0,.15)",
      border: "1px solid #f0e9fa",
      overflow: "hidden", minWidth: 220,
      animation: "fadeInDown .18s ease",
      zIndex: 9999,
    }}>
      <div style={{ background: "#6b5330", padding: "10px 16px" }}>
        <p style={{ color: "#fff", fontSize: 11, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", margin: 0 }}>
          {t("Services")}
        </p>
      </div>
      <a
        href="https://api.whatsapp.com/send?phone=+918111017771&text=Hi, I want to have a call for my custom jewel requirement!"
        target="_blank" rel="noreferrer"
        style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", textDecoration: "none", borderBottom: "1px solid #f5f0fd", transition: "background .14s" }}
        onMouseEnter={(e) => e.currentTarget.style.background = "#f0fdf4"}
        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      >
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <svg viewBox="0 0 24 24" fill="#25D366" width="18" height="18">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.09.539 4.05 1.48 5.757L0 24l6.395-1.677A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.817 9.817 0 01-5.006-1.37l-.359-.214-3.796.995.993-3.663-.235-.374A9.818 9.818 0 1112 21.818z"/>
          </svg>
        </div>
        <div>
          <p style={{ fontSize: 13, fontWeight: 600, color: "#1c1c1e", margin: 0 }}>{t("Chat on Whatsapp")}</p>
          <p style={{ fontSize: 11, color: "#888", margin: 0 }}>Chat with us anytime</p>
        </div>
      </a>
      <Link
        to="/BookAnAppointment"
        style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", textDecoration: "none", transition: "background .14s" }}
        onMouseEnter={(e) => e.currentTarget.style.background = "#faf2d3"}
        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      >
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#f3e9d3e8", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#6b5330" strokeWidth="2" width="18" height="18">
            <polygon points="23 7 16 12 23 17 23 7"/>
            <rect x="1" y="5" width="15" height="14" rx="2"/>
          </svg>
        </div>
        <div>
          <p style={{ fontSize: 13, fontWeight: 600, color: "#1c1c1e", margin: 0 }}>{t("Live Video Call")}</p>
          <p style={{ fontSize: 11, color: "#888", margin: 0 }}>Book a video appointment</p>
        </div>
      </Link>
    </div>
  );

  // ── Collections dropdown — 3-column grid ─────────────────────────────────
  const CollectionsDropdown = () => (
    <div style={{
      position: "absolute", top: "110%", left: "50%",
      transform: "translateX(-60%)",
      background: "#fff", borderRadius: 16,
      boxShadow: "0 20px 60px rgba(0,0,0,.15)",
      padding: "24px 28px", minWidth: "640px", zIndex: 9999,
      border: "1px solid #f0e9fa",
      animation: "fadeInDown .18s ease",
    }}>
      <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#b48517", margin: "0 0 18px" }}>
        {t("Browse Collections")}
      </p>
      <div className="coll-dropdown-grid">
        {headerCategories.map((col, idx) => (
          <button
            key={idx}
            onClick={() => navigateToCategory(col)}
            style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "10px 12px",
              background: "transparent",
              border: "1px solid transparent",
              borderRadius: 10,
              cursor: "pointer", transition: "all .15s", textAlign: "left",
              width: "100%",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#fffcf5";
              e.currentTarget.style.borderColor = "#f8efd9";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.borderColor = "transparent";
            }}
          >
            {/* Thumbnail */}
            <div style={{ width: 40, height: 40, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: "#f7f2f2" }}>
              <img
                src={imgSrc(col.imageUrl)}
                alt={col.categoryName}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            {/* Name */}
            <span style={{ fontSize: 13, fontWeight: 600, color: "#5c4a21", letterSpacing: ".01em", textTransform: "capitalize", flex: 1 }}>
              {col.categoryName}
            </span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ebcf8e" strokeWidth="2.5" style={{ flexShrink: 0 }}>
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <SEO title="PMR Venkateswara Jewellery" description="Premium jewellery collection." name="PMR Venkateswara Jewellery" type="article"/>
      {isMobile && (
        <div style={{ padding: "8px 20px", display: "flex", flexDirection: "column", gap: 2 }}>
          <Link
            to="/Offers"
            onClick={onClose}
            style={{ display: "block", padding: "12px 4px", fontSize: 14, fontWeight: 600, color: "#1c1c1e", textDecoration: "none", borderBottom: "1px solid #f2f2f7" }}
          >
            {t("Offers")}
          </Link>
          <Link
            to="/BookAnAppointment"
            onClick={onClose}
            style={{ display: "block", padding: "12px 4px", fontSize: 14, fontWeight: 600, color: "#1c1c1e", textDecoration: "none", borderBottom: "1px solid #f2f2f7" }}
          >
            {t("Booking Appointment")}
          </Link>
        </div>
      )}
      <ul className="pmr-nav-list">
        <div style={{ padding: "2px 24px" }}>
          <ul style={{ display: "flex", gap: "24px", alignItems: "center", height: "48px", margin: 0, padding: 0, listStyle: "none" }}>
            {visibleCategories.map((cat, item) => (
              <li
                key={item}
                className="pmr-menu-item"
                onMouseEnter={() => setActiveMenu(item)}
                onMouseLeave={() => setActiveMenu(null)}
                style={{ position: "relative" }}
              >
                <Link
                  to="/ProductList"
                  state={{ category: cat }}
                  className="pmr-menu-link"
                  style={{ textDecoration: "none", fontSize: "13px", fontWeight: 600, textTransform: "capitalize", position: "relative", paddingBottom: "6px" }}
                >
                  {cat.categoryName}
                </Link>
                {activeMenu === item && (
                  <div className="pmr-mega-dropdown" style={{ borderRadius: 16 }}>
                    <div>
                      <h6 className="mb-3" style={{ fontSize: "15px" }}>{t("Sub Categories")}</h6>
                      {cat.metaProdSubCateKeyMap && Object.entries(cat.metaProdSubCateKeyMap).map(([id, name]) => (
                        <p key={id} onClick={() => history("/ProductList", { state: { category: cat, subCategory: { id, subCategoryName: name } } })} className="pmr-dropdown-item">{name}</p>
                      ))}
                    </div>
                    <div>
                      <h6 className="me-5 mb-3" style={{ fontSize: "15px" }}>{t("Metal")}</h6>
                      {data.map((type, idx) => (
                        <p key={idx} onClick={() => history("/ProductList", { state: { type } })} className="pmr-dropdown-item">{type.name}</p>
                      ))}
                    </div>
                    <div>
                      <h6 className="mb-3" style={{ fontSize: "15px" }}>{t("Gender")}</h6>
                      {genderBasedIcons.map((item, idx) => (
                        <p key={idx} className="pmr-dropdown-item" onClick={() => history("/ProductList", { state: { gender: item.gender } })}>{item.title}</p>
                      ))}
                    </div>
                  </div>
                )}
              </li>
            ))}

            {/* Overflow categories — "More" dropdown, responsive to screen size */}
            {overflowCategories.length > 0 && (
              <li
                className="pmr-menu-item"
                onMouseEnter={() => setActiveMenu("more")}
                onMouseLeave={() => setActiveMenu(null)}
                style={{ position: "relative" }}
              >
                <span
                  className="pmr-menu-link"
                  style={{ fontSize: "13px", fontWeight: 600, textTransform: "capitalize", cursor: "pointer", paddingBottom: "6px", display: "flex", alignItems: "center", gap: 4 }}
                >
                  {t("More")}
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                    style={{ transform: activeMenu === "more" ? "rotate(180deg)" : "none", transition: "transform .2s" }}>
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </span>
                {activeMenu === "more" && (
                  <div className="pmr-mega-dropdown" style={{ width: "auto", minWidth: 200, maxHeight: 320 }}>
                    <div>
                      {overflowCategories.map((cat, idx) => (
                        <p
                          key={idx}
                          onClick={() => navigateToCategory(cat)}
                          className="pmr-dropdown-item"
                          style={{ textTransform: "capitalize" }}
                        >
                          {cat.categoryName}
                        </p>
                      ))}
                    </div>
                  </div>
                )}
              </li>
            )}

            {/* Collections nav link — 3-column grid */}
            <li
              className="pmr-menu-item"
              onMouseEnter={() => setActiveMenu("collections")}
              onMouseLeave={() => setActiveMenu(null)}
              style={{ position: "relative" }}
            >
              <span
                className="pmr-menu-link"
                style={{ fontSize: "13px", fontWeight: 600, textTransform: "uppercase", cursor: "pointer", paddingBottom: "6px" }}
              >
                {t("Collections")}
              </span>
              {activeMenu === "collections" && <CollectionsDropdown />}
            </li>
          </ul>
        </div>

        {data.length > 0 && <li className="pmr-nav-item" style={{ marginLeft: "auto" }}></li>}

        {/* Services */}
        <li
          className="pmr-menu-item me-4"
          onMouseEnter={() => setActiveMenu("service")}
          onMouseLeave={() => setActiveMenu(null)}
          style={{ position: "relative" }}
        >
          <span
            className="pmr-menu-link"
            style={{
              fontWeight: 700, fontSize: 13, display: "flex", alignItems: "center", gap: 5,
              border: "1px solid rgba(255,255,255,0.4)",
              borderRadius: 999,
              padding: "4px 14px",
              letterSpacing: ".04em",
            }}
          >
            {t("Services")}
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
              style={{ transform: activeMenu === "service" ? "rotate(180deg)" : "none", transition: "transform .2s" }}>
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </span>
          {activeMenu === "service" && (
            <div style={{ position: "absolute", top: "110%", right: 0 }}>
              <ServicesDropdown />
            </div>
          )}
        </li>
      </ul>

      <style>{`
        @keyframes fadeInDown { from { opacity:0; transform:translateY(-8px); } to { opacity:1; transform:translateY(0); } }
        .coll-dropdown-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 6px;
        }
      `}</style>
    </>
  );
}